import styled from 'styled-components';

export const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgb( 33 46 99);
  position: fixed;
  top: 0;
  max-height: 110px;
  min-height: 110px;
  width: 100%;
  border-bottom: solid 1px #818589;
`;
